import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { HealthcareEntityRep, HealthcareFacility, UserTypeEnum } from '../../../api';
import { SessionContext } from '../../contexts/SessionContext';

export const FacilityRepresentation = ({
  facility,
  className,
  sentBy,
}: {
  facility: HealthcareFacility;
  className?: string;
  sentBy?: HealthcareEntityRep;
}) => {
  const { user } = useContext(SessionContext);
  const isProvider = user?.user_type === UserTypeEnum.PROVIDER;

  const facilityUrl = isProvider
    ? `/app/provider/facility-details/${facility.id}`
    : `/app/organization/facilities/${facility.id}`;

  return (
    <div className={`facility-representation ${className}`}>
      <Link to={facilityUrl}>
        <h6 className="fw-bold mb-0">{facility.name}</h6>
      </Link>
      {facility.city && facility.state && (
        <small className="d-block">
          {facility.city}, {facility.state}
        </small>
      )}
      {sentBy && (
        <div className="text-medium mt-2">
          Sent By: {sentBy.user.first_name} {sentBy.user.last_name}
        </div>
      )}
    </div>
  );
};
